@if (shouldDisplayForm$ | async) {
  <div class="knowledge-and-experience-container tile">
    <div class="zero-text p-bigger-bold mb-3">{{ 'mydepot.trading.knowledge-and-experience.headline' | transloco }}</div>
    @if (tradeFacade.sentKnowledgeAndExperienceSuccessfully$ | async) {
      <div class="zero-text p-base-reg course-green">{{ 'mydepot.trading.knowledge-and-experience.success' | transloco }}</div>
    } @else {
      <div class="zero-text p-base-reg mb-4">{{ 'mydepot.trading.knowledge-and-experience.text' | transloco }}</div>
      <div class="d-block d-md-flex justify-content-between gap mb-3">
        <div class="mb-3 mb-md-0">
          <div class="p-base-reg mb-3">{{ 'mydepot.trading.knowledge-and-experience.complex' | transloco }}</div>
          <web-design-system-select
            class="d-block mb-2"
            [items]="cTx$ | async"
            [placeholder]="'mydepot.trading.knowledge-and-experience.tx' | transloco"
            (selectItem)="selectCTx($event)"
          />
          <web-design-system-select
            class="d-block mb-2"
            [items]="cVol$ | async"
            [placeholder]="'mydepot.trading.knowledge-and-experience.vol' | transloco"
            (selectItem)="selectCVol($event)"
          />
          <web-design-system-select
            [items]="cExp$ | async"
            [placeholder]="'mydepot.trading.knowledge-and-experience.yr' | transloco"
            (selectItem)="selectCExp($event)"
          />
        </div>
        <div>
          <div class="p-base-reg mb-3">{{ 'mydepot.trading.knowledge-and-experience.leverage' | transloco }}</div>
          <web-design-system-select
            class="d-block mb-2"
            [items]="lTx$ | async"
            [placeholder]="'mydepot.trading.knowledge-and-experience.tx' | transloco"
            (selectItem)="selectLTx($event)"
          />
          <web-design-system-select
            class="d-block mb-2"
            [items]="lVol$ | async"
            [placeholder]="'mydepot.trading.knowledge-and-experience.vol' | transloco"
            (selectItem)="selectLVol($event)"
          />
          <web-design-system-select
            [items]="lExp$ | async"
            [placeholder]="'mydepot.trading.knowledge-and-experience.yr' | transloco"
            (selectItem)="selectLExp($event)"
          />
        </div>
      </div>
      <div class="zero-text p-base-med mb-3">{{ 'mydepot.trading.knowledge-and-experience.confirm' | transloco }}</div>
      <div class="p-3 b-r-4 zero-surface grey-800 mb-3">
        <web-design-system-checkbox alignment="align-items-start" (isCheckedChange)="isCheckboxChecked = $event">
          <span class="zero-text p-small-med">{{ 'mydepot.trading.knowledge-and-experience.checkbox' | transloco }}</span>
        </web-design-system-checkbox>
      </div>
      <div class="d-flex justify-content-end">
        <web-design-system-button
          (click)="submit()"
          [disabled]="!isCheckboxChecked || (tradeFacade.sendingKnowledgeAndExperience$ | async)"
          size="small"
        >
          {{ 'mydepot.trading.knowledge-and-experience.btn' | transloco }}
        </web-design-system-button>
      </div>
    }
  </div>
}
